import React from "react"
import { NavLink, useLocation } from "react-router-dom"

import * as Icons from "../../assets/icons"
import { phone } from "../../data/Contact"

const highlights = [
  { Icon: Icons.Calendar, text: "Na rynku od 2008 roku" },
  { Icon: Icons.Language, text: "Obsługa w języku polskim" },
  { Icon: Icons.Location, text: "Dublin, Cork i cała Irlandia" },
  { Icon: Icons.Shield, text: "Bezpłatna wstępna konsultacja" },
]

const Banner = () => {
  const { pathname } = useLocation()

  if (pathname !== "/") return <div className="banner-strip" aria-hidden="true" />

  return (
    <section className="hero">
      <div className="hero-inner">
        <p className="hero-eyebrow">D&M Accountancy Services</p>
        <h1 className="hero-title">
          Polskie biuro księgowe <span>w Irlandii</span>
        </h1>
        <p className="hero-lead">
          Księgowość dla Sole Traderów i spółek LTD, rozliczenia z Revenue, zwrot podatku z P60 i ulgi
          podatkowe. Dublin, Cork i cała Irlandia – po polsku.
        </p>
        <div className="hero-actions">
          <NavLink to="/kontakt" className="button button-primary button-large">
            Umów bezpłatną konsultację <Icons.ArrowRight />
          </NavLink>
          <a href={phone.href} className="button button-ghost button-large">
            <Icons.Phone /> {phone.display}
          </a>
        </div>
      </div>
      <ul className="hero-highlights">
        {highlights.map(({ Icon, text }) => (
          <li key={text}>
            <Icon /> {text}
          </li>
        ))}
      </ul>
    </section>
  )
}

export default Banner
